import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "donation_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.429 19.223V11.1h1.447c.106 0 .211.011.317.034.105.022.211.048.317.079l6.265 2.317c.211.075.38.21.509.405.128.195.192.397.192.607 0 .316-.11.57-.328.765a1.104 1.104 0 0 1-.758.293h-2.375a.943.943 0 0 1-.17-.011.63.63 0 0 1-.146-.056l-1.448-.563-.294.877 1.742.608c.03.015.075.026.136.034.06.007.113.011.158.011h6.197c.483 0 .905.172 1.267.517A1.7 1.7 0 0 1 21 18.3L13.784 21 7.43 19.223ZM2 21v-9.9h3.619V21H2Zm13.571-8.1-3.754-3.645a7.069 7.069 0 0 1-1.188-1.496 3.448 3.448 0 0 1-.486-1.789c0-.825.29-1.526.87-2.104A2.887 2.887 0 0 1 13.13 3c.482 0 .934.101 1.357.304.422.202.784.476 1.085.821a3.349 3.349 0 0 1 1.086-.821A3.098 3.098 0 0 1 18.014 3c.83 0 1.535.289 2.115.866.58.578.871 1.279.871 2.104a3.51 3.51 0 0 1-.475 1.789 6.786 6.786 0 0 1-1.176 1.496L15.57 12.9Z"
    }, null, -1)
  ]))]))
}
export default { render: render }